import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaX, FaEye, FaEyeSlash } from "react-icons/fa6";
import { useAuth } from "../../context/AuthContext";
import NavbarRegistro from "../../components/NavbarRegistro";
import "./login-registro.css";

const Registro = () => {
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [dni, setDni] = useState("");
  const [correo, setCorreo] = useState("");
  const [telefono, setTelefono] = useState("");
  const [direccion, setDireccion] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [ayudaEmpleo, setAyudaEmpleo] = useState(false);
  const [ayudaSocial, setAyudaSocial] = useState(false);
  const [observaciones, setObservaciones] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [necesidades, setNecesidades] = useState([]);

  // Para mostrar/ocultar contraseña
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Expresión regular para validar la contraseña
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

  // HOOK para redirigir y autenticación
  const navigate = useNavigate();
  const { register, isLoading } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. Comprobamos que todos los campos estén rellenos
    if (
      !nombre ||
      !apellido ||
      !dni ||
      !correo ||
      !telefono ||
      !direccion ||
      !municipio ||
      !password ||
      !confirmPassword
    ) {
      toast.error("Por favor, rellena todos los campos con *.");
      return;
    }

    // 2. Comprobamos que se han aceptado los términos
    if (!termsAccepted) {
      toast.error("Debes aceptar los Términos y Condiciones de uso.");
      return;
    }

    // 3. Validamos que al menos uno de los checkboxes esté seleccionado
    if (necesidades.length === 0) {
      toast.error(
        "Debes seleccionar al menos una de las opciones en ¿Qué necesitas?"
      );
      return;
    }

    // 4. Comprobamos que la contraseña cumple con los requisitos
    if (!passwordRegex.test(password)) {
      toast.error(
        "La contraseña debe tener mínimo 8 caracteres, incluyendo una mayúscula, una minúscula, un número y un carácter especial."
      );
      return;
    }

    // 5. Comprobamos que ambas contraseñas coincidan
    if (password !== confirmPassword) {
      toast.error("Las contraseñas no coinciden.");
      return;
    }

    // 6. Formulario válido: enviamos datos usando el nuevo sistema de autenticación
    try {
      const registrationData = {
        nombre,
        apellido,
        dni,
        correo,
        telefono,
        direccion,
        municipio,
        password,
        necesidades,
        observaciones,
      };
      // console.log('necesidades', necesidades);

      const result = await register(registrationData);

      if (result.isSuccess) {
        toast.success(result.message || "Registro enviado correctamente");
        navigate("/registro-enviado"); // Redirección a la página de confirmación
      } else {
        toast.error(result.error || "Ha ocurrido un error durante el registro");
      }
    } catch (error) {
      toast.error("Ha ocurrido un error inesperado durante el registro");
    }
  };

  return (
    <>
      <NavbarRegistro />

      <main className="formulario-registro flex-center">
        <form
          onSubmit={handleSubmit}
          className="formulario column fondo-blanco relative"
          autoComplete="off" 
        >
          {/* Botón cerrar X */}
          <Link to="/" className="cerrar verde absolute">
            <FaX />
          </Link>

          {/* Nombre + apellidos + dni + tel */}
          <div className="linea wrap">
            {/* Nombre */}
            <div className="campo column">
              <label className="verde mayusculas">Nombre *</label>
              <input
                className="w-175"
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre"
                required
                disabled={isLoading}
              />
            </div>

            {/*  Apellidos */}
            <div className="campo column">
              <label className="verde mayusculas">Apellidos *</label>
              <input
                className="w-250"
                type="text"
                value={apellido}
                onChange={(e) => setApellido(e.target.value)}
                placeholder="Apellido Apellido"
                required
                disabled={isLoading}
              />
            </div>

            {/* dni */}
            <div className="campo column dni w-90">
              <label className="verde mayusculas">DNI *</label>
              <input
                type="text"
                value={dni}
                onChange={(e) => setDni(e.target.value)}
                placeholder="12345678A"
                required
                disabled={isLoading}
              />
            </div>

            {/* email */}
            <div className="campo column correo">
              <label className="verde mayusculas">Correo Electrónico *</label>
              <input
                className="w-300"
                type="email"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                placeholder="correoelectronico@gmail.com"
                required
                disabled={isLoading}
              />
            </div>

            {/* tel */}
            <div className="campo column telefono">
              <label className="verde mayusculas">Teléfono *</label>
              <input
                className="w100"
                type="tel"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
                placeholder="123456789"
                required
                disabled={isLoading}
              />
            </div>

            {/* direccion */}
            <div className="campo column direccion">
              <label className="verde mayusculas">Dirección *</label>
              <input
                type="text"
                value={direccion}
                onChange={(e) => setDireccion(e.target.value)}
                placeholder="Lugar de residencia"
                required
                disabled={isLoading}
              />
            </div>

            {/* c.p. */}
            <div className="campo column municipio w-150">
              <label className="verde mayusculas">Código postal *</label>
              <select
                required
                value={municipio}
                onChange={(e) => setMunicipio(e.target.value)}
                disabled={isLoading}
              >
                <option value="" disabled hidden>
                  XXXXX
                </option>
                <option value="21410">21410</option>
                <option value="21420">21420</option>
                <option value="21430 ">21430 </option>
                <option value="21449">21449</option>
              </select>
            </div>

            {/* contraseña */}
            <div className="campo password-group column relative">
              <label className="verde mayusculas">Contraseña *</label>
              <div className="password-field align-center">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="****************"
                  required
                  disabled={isLoading}
                  autoComplete="new-password"
                />
                {showPassword ? (
                  <FaEyeSlash
                    className="ojo"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                ) : (
                  <FaEye
                    className="ojo"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                )}
              </div>
            </div>

            {/* repetir contraseña */}
            <div className="campo password-group column relative">
              <label className="verde mayusculas">Confirmar Contraseña *</label>
              <div className="password-field align-center">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="****************"
                  required
                  disabled={isLoading}
                />
                {showConfirmPassword ? (
                  <FaEyeSlash
                    className="ojo"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  />
                ) : (
                  <FaEye
                    className="ojo"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  />
                )}
              </div>
            </div>
          </div>

          {/* checkbox + textarea */}
          <div className="linea wrap">
            {/* checkbox */}
            <div className="campo">
              <p className="mayusculas verde mb-10">¿QUÉ NECESITAS? *</p>
              <div className="checkbox flex w-100">
                <input
                  type="checkbox"
                  id="empleo"
                  name="empleo"
                  value="empleo_formacion"
                  className="accent-green-900"
                  checked={necesidades.includes("empleo_formacion")}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setNecesidades([...necesidades, e.target.value]);
                    } else {
                      setNecesidades(necesidades.filter((n) => n !== e.target.value));
                    }
                  }}
                  disabled={isLoading}
                />
                <label for="empleo">Ayuda con empleo/formación</label>
              </div>
              <div className="checkbox flex w-100">
                <input
                  type="checkbox"
                  id="social"
                  name="social"
                  value="ayuda_social"
                   className="accent-green-900"
                  checked={necesidades.includes("ayuda_social")}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setNecesidades([...necesidades, e.target.value]);
                    } else {
                      setNecesidades(necesidades.filter((n) => n !== e.target.value));
                    }
                  }}
                  disabled={isLoading}
                />
                <label for="social">Ayuda social</label>
              </div>
            </div>

            {/* Textarea */}
            <div className="campo column sobre-mi w-50p">
              <label className="verde mayusculas mb-10">Observaciones</label>
              <textarea
                placeholder="Si necesitas comentarnos alguna situación en concreto, hazlo aquí."
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
                disabled={isLoading}
              />
            </div>
          </div>

          {/* terminos/condiciones + botón registro */}
          <div className="terminos-enviar between">
            {/* terminos/condiciones */}
            <div className="campo terminos align-center">
              <input
                type="checkbox"
                 className="accent-green-900"
                id="terminos"
                checked={termsAccepted}
                onChange={() => setTermsAccepted(!termsAccepted)}
                disabled={isLoading}
              />
              <label htmlFor="terminos">
                {" "}
                He leído y acepto los{" "}
                <Link to="/terminos-condiciones">
                  Términos y Condiciones de uso
                </Link>
              </label>
            </div>

            {/* mensajes error + botón registro */}
            <div className="error-boton-container align-center gap-15">
              <button
                type="submit"
                className="fondo-blanco verde"
                disabled={isLoading}
              >
                {isLoading ? "Registrando..." : "Registrarme"}
              </button>
            </div>
          </div>
        </form>
      </main>
    </>
  );
};

export default Registro;
